import { jsx as _jsx } from "react/jsx-runtime";
import showToast from "../../../services/toast";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import React from "react";
export var InsurancePoliciesHeader = function (props) {
    return (_jsx(AlertLoadingHeader, { loading: props.loading, seeToast: props.seeToast, showToast: showToast, setSeeToast: props.setSeeToast, titleLoading: props.isLoadin ? "Descargando archivo" : "Cargando..." }));
};
